import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "w100" }
const _hoisted_13 = {
  key: 0,
  class: "fs14 whiteColor fw600 mc"
}
const _hoisted_14 = {
  key: 1,
  class: "fs14 whiteColor fw600 mc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.type == `horizontal` ? `fl mr15` : ``}`)
    }, [
      _createVNode(_component_MdTextfieldTag, {
        name: "メールアドレス",
        style: {"height":"56px","min-width":"280px"},
        class: "fl fs14",
        value: _ctx.Util.isSMSEmail(_ctx.member.email) ? null : _ctx.member.email,
        onInputValue: _ctx.inputClientAddress,
        onBlur: _ctx.checkEmailField,
        errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null,
        required: ""
      }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"])
    ], 2),
    (_ctx.type != `horizontal`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.type == `horizontal` ? `fl` : ``}`)
    }, [
      _createVNode(_component_MdTextfieldTag, {
        name: "氏名 メールを送信する際に利用",
        style: {"height":"56px","min-width":"280px"},
        fieldStyle: "min-width:280px;",
        class: "fl fs14",
        value: _ctx.member.name,
        onInputValue: _ctx.inputClientName,
        required: ""
      }, null, 8, ["value", "onInputValue"])
    ], 2),
    (_ctx.type != `horizontal`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.type == `horizontal` ? `fl mr15` : ``}`)
    }, [
      _createVNode(_component_MdTextfieldTag, {
        name: "所属名 メールを送信する際に利用",
        placeholder: "waaq株式会社 / waaq大学",
        style: {"height":"56px","min-width":"280px"},
        fieldStyle: "min-width:280px;",
        class: "fl fs14",
        value: _ctx.member.company_name,
        onInputValue: _ctx.inputCompanyName
      }, null, 8, ["value", "onInputValue"])
    ], 2),
    (_ctx.type != `horizontal`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true),
    _hoisted_10,
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("section", {
        class: "circle_button skyblueBg fffColor fs16 pointer centered mc w100",
        style: {"padding":"6px 12px","max-width":"400px"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAttendee && _ctx.addAttendee(...args)))
      }, [
        (_ctx.action == `edit`)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "変更"))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, "追加"))
      ])
    ])
  ]))
}